import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { EmailTemplatePreview } from 'components/EmailTemplatePreview/EmailTemplatePreview';

export const EmailTemplatePreviewModal = ({
  brand,
  template,
  textParams,
  showSupportFooter,
  visible,
  onClose,
}) => {
  return (
    <AnimatedModal visible={visible} onClose={onClose} title="Preview" small>
      {visible && (
        <EmailTemplatePreview
          brand={brand}
          className="min-h-[18rem] w-full flex-1 lg:min-h-0"
          subject={template?.subject}
          body={template?.body}
          showSupportFooter={showSupportFooter}
          showActions
          textParams={textParams}
        />
      )}
    </AnimatedModal>
  );
};
